const DICTIONARIES = {
  en: {
    do_submitted_successfully: 'DO submitted successfully',
    hold_approve_do_success: {
      approve: 'DO is unhold successfully',
      hold: 'DO is hold successfully',
    },
    hold_approve_do_subtitle: {
      approve: 'This will no longer put the DO on Hold.',
      hold: 'Holding an entire DO will make all destinations marked as on Hold',
    },
    needs_review_submit_error: 'Can\'t submit payable other than Needs Review Payable in Review Shipper Payable review page.',
    pot_modal: {
      subtitle: 'Input links to POT files',
      title: 'Upload Multiple POT',
    },
    success_resync_awb: 'Success on resync all AWB',
    x_removed_from_review_list: '{{x}} removed from review list',
  },
};

export default DICTIONARIES;
